import { ParameterTypeEnum } from 'src/app/enums/parameterType.enum';
import { ParameterLookup } from 'src/app/models/parameter.model';

const backendKeyAliases: [string, ParameterTypeEnum][] = [
  ['MeasuredRespirableCrystallineSilica', ParameterTypeEnum.MeasuredRCS],
];

const parameterTypeByKey: Map<string, number> = new Map([
  ...Object.keys(ParameterTypeEnum)
    .filter((key) => isNaN(Number(key)))
    .map((key): [string, number] => [key, ParameterTypeEnum[key as keyof typeof ParameterTypeEnum]]),
  ...backendKeyAliases,
].map(([key, type]): [string, number] => [key.toLowerCase(), type]));

const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;

export function findFirstCitedParameter(
  parameterNames: string | null | undefined,
  lookups: ParameterLookup[],
  current: ParameterLookup | null = null
): ParameterLookup | null {
  const requestedKeys = (parameterNames ?? '')
    .split(',')
    .map((name) => name.trim().toLowerCase())
    .filter((name) => name.length > 0);

  for (const requestedKey of requestedKeys) {
    if (current?.id.toLowerCase() === requestedKey) {
      return current;
    }
    const citedLookup = lookups.find((lookup) => lookup.id.toLowerCase() === requestedKey);
    if (citedLookup) {
      return citedLookup;
    }
  }

  if (requestedKeys.some((requestedKey) => guidPattern.test(requestedKey))) {
    return null;
  }

  for (const requestedKey of requestedKeys) {
    const parameterType = parameterTypeByKey.get(requestedKey);
    if (parameterType === undefined) {
      continue;
    }
    if (current?.parameterType === parameterType) {
      return current;
    }
    const match = lookups.find((lookup) => lookup.parameterType === parameterType);
    if (match) {
      return match;
    }
  }

  return null;
}
